import { AppContext } from '@/contexts/app.context';
import { Box, CircularProgress, SxProps } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { fileApi } from '@/generated/clients';
import notFoundImage from '@/images/image-not-found.png';

export type VideoFromServerProps = {
  fluid?: boolean;
  id?: string;
  sx?: SxProps;
};

export const VideoFromServer = (props: VideoFromServerProps) => {
  const [objectUrl, setObjectUrl] = useState<string>();
  const [imageNotFound, setImageNotFound] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const load = async (id: string) => {
    try {
      const response = (await fileApi.fileGetFileByIdRaw({ id })).raw;
      if (response.blob) setObjectUrl(URL.createObjectURL(await response.blob()));
      else {
        setLoading(false);
        setImageNotFound(true);
      }
    } catch (e) {
      setImageNotFound(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!props.id) {
      setLoading(false);
      setImageNotFound(true);
      return;
    }
    if (!objectUrl) {
      load(props.id);
    } else {
      setLoading(false);
    }
  }, [props.id]);

  if (loading) return <CircularProgress />;

  if (objectUrl) return <Box controls {...props} sx={{ objectFit: 'contain', ...props.sx }} src={objectUrl} component={'video'} />;

  if (imageNotFound) return <Box {...props} style={{ objectFit: 'cover', width: '100%', height: '100%' }} src={notFoundImage} component={'img'} />;

  return <></>;
};
